import 'core-js/modules/es.promise';

// core-js map breaks v9 players - use es6-map
import 'es6-map/implement';
// import 'core-js/modules/es.map';

import 'core-js/modules/es.set';
import 'core-js/modules/es.symbol';
import 'core-js/modules/es.array.from';
import 'core-js/modules/es.array.includes';
import 'core-js/modules/es.array.iterator';
import 'core-js/modules/es.string.includes';
import 'core-js/modules/es.object.assign';
